<template>
    <div class="modal fade" id="createPersonModal" role="dialog" aria-labelledby="createPersonModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="createPersonModalLabel">{{$t('person.create')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <person-edit-card v-model="model"
                                      v-if="showEditor"
                                      :create="true"
                                      :validateUniqueIdNumber="false"
                                      :validateEgn="true"
                                      @save="onSave"
                                      @cancel="onCancel">
                    </person-edit-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Person } from '../../models/models';
    import PersonEditCard from './PersonEditCard';

    export default {
        components: {
            PersonEditCard
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            profileManagement: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new Person(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Person();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onCreate', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Person();
                    this.model.profileManagement = this.profileManagement;
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
